import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../api';

const withWaterGymProtection = (Component) => {
  const ProtectedRoute = (props) => {
    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);

    useEffect(() => {
      const checkAccess = async () => {
        try {
          const res = await api.get('/v1/special-trainers/15/state', { withCredentials: true });
          const defeated = Boolean(res?.data?.defeated);
          setHasAccess(defeated);
          if (!defeated) {
            toast.warning('You must defeat the Mystery Man to enter the Water Gym.', {
              position: 'top-center',
              autoClose: 3000
            });
          }
        } catch (e) {
          setHasAccess(false);
          toast.warning('You must defeat the Mystery Man to enter the Water Gym.', {
            position: 'top-center',
            autoClose: 3000
          });
        } finally {
          setLoading(false);
        }
      };

      checkAccess();
    }, []);

    if (loading) {
      return (
        <div className="safari-zone-loading">
          <div className="loading-spinner"></div>
          <div className="loading-text">Checking Water Gym access...</div>
          <style jsx="true">{`
            .safari-zone-loading {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              background-color: rgba(0, 0, 0, 0.7);
              z-index: 9999;
            }
            
            .loading-spinner {
              width: 50px;
              height: 50px;
              border: 5px solid #60a5fa;
              border-top-color: transparent;
              border-radius: 50%;
              animation: spin 1s linear infinite;
              margin-bottom: 20px;
            }
            
            .loading-text {
              color: white;
              font-size: 18px;
              font-weight: bold;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
            }
            
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      );
    }

    if (!hasAccess) {
      return <Navigate to="/map/Island" replace />;
    }

    return <Component {...props} />;
  };

  return ProtectedRoute;
};

export default withWaterGymProtection;
